<template>
    <div>
        <div v-if="usuarioLogado" class="flotante-sec" v-bind:class="showMenu ? 'flotante-sec-open' : ''">
            <div v-if="showMenu">
                <div
                    v-if="possuiPermissao('DASHBOARD_CALENDARIO_V')"
                    class="transaction-btn-float mb-1 btn-float-common-open"
                    v-bind:class="activePath === '/' ? 'btn-disable' : ''"
                    @click="showRoute('/')"
                    title="Dashboard"
                >
                    <CalendarIcon/>
					<div class="label-text-float-menu">
						<span>Dashboard</span>
					</div>
                </div>
                <div
                    v-if="(possuiPermissao('GER_I_RENDAS') || possuiPermissao('GER_I_AGENDAMENTOS')) || possuiPermissao('GER_I_RECEIVE')"
                        class="transaction-btn-float mb-1 btn-float-common-open"
                        v-bind:class="showModalTransaction ? 'btn-disable' : ''"
                        @click="showTransaction"
                        title="Transações"
                    >
                    <TransactionsCustomIcon/>
					<div class="label-text-float-menu">
						<span>Transações</span>
					</div>
                </div>
				<div
                    v-if="possuiPermissao('GER_I_VENDA') || possuiPermissao('GER_U_VENDA')"
                        class="transaction-btn-float mb-1 btn-float-common-open"
                        v-bind:class="activePath === '/commercialManagement/sale' ? 'btn-disable' : ''"
                        @click="showRoute('/commercialManagement/sale')"
                        title="Vendas"
                    >
                    <dollarSignIcon/>
					<div class="label-text-float-menu">
						<span>Vendas</span>
					</div>
                </div>
				<div
                    v-if="possuiPermissao('GER_I_ORCAMENTO') || possuiPermissao('GER_U_ORCAMENTO')"
                        class="transaction-btn-float mb-1 btn-float-common-open"
                        v-bind:class="activePath === '/commercialManagement/budget' ? 'btn-disable' : ''"
                        @click="showRoute('/commercialManagement/budget')"
                        title="Orçamentos"
                    >
                    <edit3Icon/>
					<div class="label-text-float-menu">
						<span>Orçamentos</span>
					</div>
                </div>
            </div>
        </div>
		<div v-if="usuarioLogado" class="flotante" v-bind:class="showMenu ? 'flotante-open' : ''">
			<div
				class="btn-menu-float btn-float-common"
				@click="showMenu = !showMenu"
				title="Opcoes"
				v-click-outside="onClickOutside"
			>
				<StarIcon/>
			</div>
		</div>
        <section v-if="showModalTransaction">
            <Transactions
                :transactionDocument="{}"
                @closeModalTransaction="closeModalTransaction"
                :typeTransactionDefault="null"
                @saved="reload()"
            />
        </section>
    </div>
</template>

<script>
	import { possuiPermissao } from "@/helpers/permissions";
	import { mapState } from "vuex";
	import Transactions from "@/components/Transactions/Transactions.vue";
	import { AccountService } from "../services/account";
	import { CategoryExpensesService } from "../services/categoryExpenses";
	import { CustomerService } from "../services/customer";
	import emitter from "@/eventBus.js";
	import clickOutside from "@/directives/click-outside.js";
	import { ProductService } from "../services/product";
	import { ProductClassService } from "../services/productClass";
	import { TaxeService } from "../services/taxe";
	import { AccountClassService } from "../services/accountClass";

	export default {
		name: "MenuFloat",
		components: {
			Transactions
		},

		directives: { clickOutside },

		data () {
			return {
				showMenu: false,
				dicionaryRoutes: {
					transaction: {
						idx: 4,
						incomeRecord: 0,
						expenseRecord: 1,
						receiveRecord: 2
					}
				},
				possuiPermissao,
				showModalTransaction: false,

				accountService: new AccountService(),
				categoryService: new CategoryExpensesService(),
				customerService: new CustomerService(),
				productService: new ProductService(),
				productClassService: new ProductClassService(),
				taxeService: new TaxeService(),
				accountClassService: new AccountClassService(),

				optionsAccount: [],
				optionsCategory: [],
				optionsCustomer: []
			};
		},

		props: {},

		watch: {
			usuarioLogado () {
				this.findParams();
			},
			account () {
				this.optionsAccount = this.account;
			},
			category () {
				this.optionsCategory = this.category;
			},
			customer () {
				this.optionsCustomer = this.customer;
			}
		},

		computed: {
			...mapState(["usuarioLogado", "account", "category", "customer", "product", "productClass", "taxe", "accountClass"]),
			activePath () {
				return this.$route.path;
			}
		},

		beforeDestroy () {
			emitter.off("reloadAccount");
			emitter.off("reloadAccountClass");
			emitter.off("reloadCategory");
			emitter.off("reloadCustomer");
			emitter.off("reloadProduct");
			emitter.off("reloadProductClass");
			emitter.off("reloadTaxe");
		},

		async mounted () {
			this.findParams();

			emitter.on("reloadAccount", (reload) => {
				if (reload) {
					this.findAccount();
				}
			});
			emitter.on("reloadAccountClass", (reload) => {
				if (reload) {
					this.findAccountClass();
				}
			});
			emitter.on("reloadCategory", (reload) => {
				if (reload) {
					this.findCategory();
				}
			});
			emitter.on("reloadCustomer", (reload) => {
				if (reload) {
					this.findCustomer();
				}
			});
			emitter.on("reloadProduct", (reload) => {
				if (reload) {
					this.findProduct();
				}
			});
			emitter.on("reloadProductClass", (reload) => {
				if (reload) {
					this.findProductClass();
				}
			});
			emitter.on("reloadTaxe", (reload) => {
				if (reload) {
					this.findTaxe();
				}
			});
		},

		methods: {
			async findParams () {
				if (!this.usuarioLogado) return;
				const loadParams = [];

				if (!this.account)
					loadParams.push(this.findAccount());

				if (!this.accountClass)
					loadParams.push(this.findAccountClass());

				if (!this.category)
					loadParams.push(this.findCategory());

				if (!this.customer)
					loadParams.push(this.findCustomer());

				if (!this.product)
					loadParams.push(this.findProduct());

				if (!this.productClass)
					loadParams.push(this.findProductClass());

				if (!this.taxe)
					loadParams.push(this.findTaxe());

				await Promise.all(loadParams);
			},

			showRoute (path, haveProp) {
				if ( this.$route.path === path) return;
				const nomeRoute = path.substring(1).split("/");
				if (nomeRoute.length == 2 && haveProp) {
					const idxPath = this.dicionaryRoutes[nomeRoute[0]].idx;
					const idxChildren = this.dicionaryRoutes[nomeRoute[0]][nomeRoute[1]];
					this.$router.options.routes[idxPath].children[idxChildren].props.newRecord = true;
				}
				this.$router.push({ path });
				this.showMenu = false;
			},

			closeModalTransaction () {
				this.showModalTransaction = false;
			},

			async showTransaction () {
				this.showMenu = false;
				this.showModalTransaction = true;
			},

			async findCategory () {
				if (!possuiPermissao("GER_V_CATEGORIAS"))
					return;

				const result = await this.categoryService.listCategoryExpenses({offset: 0, limit: null}) || {};
				const categorys = result.rows?.map(item => ({
					text: item.description,
					value: item.idCategoryExpense,
					income: item.income,
					inactive: item.inactive
				})) || [];

				this.$store.commit("setCategory", categorys);
			},

			async findAccount () {
				if (!possuiPermissao("GER_V_CONTAS"))
					return;

				const result = await this.accountService.listAccount({offset: 0, limit: null}) || {};
				const accounts = result.rows?.map(item => ({
					text: item.description,
					value: item.idAccount,
					permiteParcelas: item.accountClass.closeMonthly,
					permitePagamento: item.accountClass.automaticPay,
					closingDay: item.closingDay,
					payDay: item.payDay,
					closeNextDayWeekend: item.closeNextDayWeekend,
					balance: item.balance,
					inactive: item.inactive
				})) || [];
				this.$store.commit("setAccount", accounts);
			},

			async findAccountClass () {
				if (!possuiPermissao("GER_V_TIPOS"))
					return;

				const result = await this.accountClassService.listAccountClass({offset: 0, limit: null}) || {};
				const accountClass = result.rows?.map(item => item);

				this.$store.commit("setAccountClass", accountClass);
			},

			async findCustomer () {
				if (!possuiPermissao("GER_V_CUSTOMER"))
					return;

				const result = await this.customerService.listCustomer({offset: 0, limit: null}) || {};
				const customers = result.rows?.reduce((acc, item) => {
					if (item.eventual) return acc;

					let description = item.description;
					if (item.identityDocument)
						description = description.concat(` - ${item.identityDocument}`);

					acc.push({
						text: description,
						value: item.idCustomer,
						cellPhone: item.cellPhone,
						telephone: item.telePhone,
						address: item.address,
						identityDocument: item.identityDocument,
						description: item.description
					});

					return acc;
				}, []);

				this.$store.commit("setCustomer", customers);
			},

			async findProduct () {
				if (!possuiPermissao("GER_V_PRODUTOS"))
					return;

				const result = await this.productService.listProduct({offset: 0, limit: null}) || {};
				const products = result.rows?.map(item => item);

				this.$store.commit("setProduct", products);
			},

			async findProductClass () {
				if (!possuiPermissao("GER_V_PRODUTOS"))
					return;

				const result = await this.productClassService.listProductClass({offset: 0, limit: null}) || {};
				const productsClass = result.rows?.map(item => item);

				this.$store.commit("setProductClass", productsClass);
			},

			async findTaxe () {
				if (!possuiPermissao("GER_V_TRIBUTO"))
					return;

				const result = await this.taxeService.listTaxe({offset: 0, limit: null}) || {};
				const taxe = result.rows?.map(item => item);

				this.$store.commit("setTaxe", taxe);
			},

			async reload () {
				if (!this.usuarioLogado) return;

				if ( this.$route.path === "/")
					emitter.emit("reloadTransactions", { reload: true });

				if (this.$route.path === "/transaction/transactionsRecord")
					emitter.emit("reloadListTransaction", { reload: true });
			},

			onClickOutside () {
				this.showMenu = false;
			}
		}
	};
</script>